import React, { useState, useEffect } from "react";
import "./Login.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import api from "../../../../utils/apidsf.js";
import logoImg from "../../../../image/lexpedia-logo.jpg";
import { CheckToken } from "../../../../actions/userAction.js";

const Login = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(selector);
  }, [selector]);

  useEffect(async () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    await api
      .get("/auth/me", config)
      .then((res) => {
        console.log(res?.data);
        if (res?.data?.success) {
          navigate("/admin/home");
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        console.log(err);
        navigate("/");
      });
  }, []);
  const signSubmit = async (e) => {
    e.preventDefault();
  };

  const loginsubmit = async (e) => {
    e.preventDefault();
    const { email, password } = e.target;
    console.log(email.value);
    let logindata = {
      email: email.value,
      password: password.value,
    };

    api
      .post("/auth/login", logindata)
      .then((res) => {
        if (res?.data?.role !== "admin") {
          return swal({
            title: "Error",
            text: "User can not access this dashboard",
            icon: "error",
            // button: "Try again!",
          });
        }
        if (res?.data?.success) {
          let token = `Bearer ${res?.data?.token}`;
          localStorage.setItem("token", JSON.stringify(token));
          console.log(res.data.role);
          swal({
            title: "Success",
            text: "LogIn Success",
            icon: "success",
            button: "Go to Admin!",
          }).then((value) => {
            console.log(res);
            if (res?.data?.role == "admin") {
              navigate("/admin/home");
            }
          });
        } else {
          swal({
            title: "Error",
            text: res?.data?.error,
            icon: "error",
            button: "Try again!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        swal({
          title: "Error",
          text: "There is Error--Wronge Password Or email Try again",
          icon: "error",
          button: "Try again!",
        });
      });
  };

  return (
    <div className="login_bg">
      <div className="details_main">
        <img src={logoImg} />

        <div className="login">
          <form onSubmit={loginsubmit}>
            <label for="chk" aria-hidden="true">
              Admin Login
            </label>
            <input type="email" name="email" placeholder="Email" required="" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              required=""
            />
            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
